import React from 'react';

import { useTranslation } from 'react-i18next';

import { ChevronIcon } from '@icons';

import { useModals } from '@shared/contexts';
import { PromotionParticipantsType } from '@shared/types';

import { useQuerySinglePromotion } from '@hooks/api/promotions/use-query-single-promotion';

import { Modal } from '@components/modal';

import { ModalName } from '../types';
import * as Styled from './promotion-participants-modal.styled';

interface ModalDataType {
	participants: PromotionParticipantsType[];
	promo_id: string;
}

const PromotionParticipantsModal = () => {
	const { isModalOpen, closeModal, getModalData } = useModals();
	const { t } = useTranslation('promotions');
	const [page, setPage] = React.useState<number>(1);
	const modalData = getModalData<ModalDataType>(ModalName.PROMOTION_PARTICIPANTS);
	const [participants, setParticipants] = React.useState<PromotionParticipantsType[]>([]);

	const { data: promo } = useQuerySinglePromotion(modalData ? modalData.promo_id : '', 10, page);

	React.useEffect(() => {
		if (promo && promo.subscriptions) {
			const merged = new Map([...participants, ...promo.subscriptions].map(p => [p.subscribed_at, p]));
			setParticipants(Array.from(merged.values()));
		}
	}, [promo]);

	const handleShowMore = () => {
		if (promo && promo.pagination.next_page) {
			setPage(promo.pagination.next_page);
		}
	};

	return (
		<Modal
			title={t('participants_table')}
			isOpen={isModalOpen(ModalName.PROMOTION_PARTICIPANTS)}
			closeModal={closeModal}
			noTitleBorder
		>
			<Styled.Wrapper>
				{promo && promo.subscriptions && promo.subscriptions.length > 0 ? (
					<>
						<Styled.Title>{t('participants')}</Styled.Title>
						<Styled.TitleRow>
							<Styled.ParticipantsCountContainer>
								<Styled.ParticipantsCountText>{t('main:total')}:</Styled.ParticipantsCountText>
								<Styled.ParticipantsCount>{promo.pagination.total_count}</Styled.ParticipantsCount>
							</Styled.ParticipantsCountContainer>
						</Styled.TitleRow>
						<Styled.ParticipantsGrid>
							{participants.map((participants, index) => (
								<Styled.ParticipantsRow key={index}>
									<Styled.ParticipantNumber>{index + 1}</Styled.ParticipantNumber>
									<Styled.ParticipantId>{participants.user_pm_id}</Styled.ParticipantId>
								</Styled.ParticipantsRow>
							))}
						</Styled.ParticipantsGrid>
					</>
				) : (
					<Styled.NoParticipants>{t('noParticipantsYet')}</Styled.NoParticipants>
				)}
				{promo && page < (promo.pagination?.total_pages || 1) && (
					<Styled.ShowMoreRow>
						<Styled.ShowMoreBtn onClick={() => handleShowMore()}>
							{t('showMore')}
							<Styled.ShowMoreIconWrapper>
								<ChevronIcon />
							</Styled.ShowMoreIconWrapper>
						</Styled.ShowMoreBtn>
					</Styled.ShowMoreRow>
				)}
			</Styled.Wrapper>
		</Modal>
	);
};

export default PromotionParticipantsModal;
